document.addEventListener('click', function(e) {
  const trigger = e.target.closest('a[href="#etiquette-produit"]');
  if (trigger) {
    e.preventDefault();
    if (document.querySelector('.sleek-pdp__label-modal')) return;

    const mainContent = document.getElementById('MainContent');
    if (!mainContent) return;

    const modalHTML = `
      <div class="sleek-pdp__label-modal is-open" data-sp-label-modal="">
        <div class="sleek-pdp__label-modal-overlay" data-sp-label-close=""></div>
        <div class="sleek-pdp__label-modal-body">
          <button class="sleek-pdp__label-modal-close" data-sp-label-close="">×</button>
          <div>
            <img src="https://cdn.shopify.com/s/files/1/0925/4581/0809/files/tiquette_du_produit_sleek.png?v=1773057171" alt="Étiquette du produit" loading="lazy">
            <img src="https://cdn.shopify.com/s/files/1/0925/4581/0809/files/tableau_nutritionnel.jpg?v=1773056666" alt="Tableau nutritionnel" loading="lazy" style="margin-top: 16px;">
          </div>
        </div>
      </div>
    `;

    mainContent.insertAdjacentHTML('afterbegin', modalHTML);
    return;
  }

  if (e.target.closest('.sleek-pdp__label-modal-close, .sleek-pdp__label-modal-overlay')) {
    const modal = document.querySelector('.sleek-pdp__label-modal');
    if (modal) modal.remove();
  }
});



document.addEventListener("DOMContentLoaded", function() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  let lastTotal = null;

  const updateShipping = () => {
    const shippingPriceEl = document.querySelector('.livraison-gratuite .cart__total__price');
    const cartTotalEl = document.querySelector('[data-cart-total]');
    if (!shippingPriceEl || !cartTotalEl) return;

    const cartTotal = parseFloat(cartTotalEl.getAttribute('data-cart-total'));
    if (cartTotal === lastTotal) return; // évite les appels redondants
    lastTotal = cartTotal;

    const seuil = parseFloat(shippingPriceEl.getAttribute('prix-free-shipping'));
    shippingPriceEl.textContent = cartTotal >= seuil ? "GRATUITE" : "À l'étape suivante";
    console.log('cartTotal:', cartTotal, '/ seuil:', seuil);
  };

  updateShipping();

  const observer = new MutationObserver(updateShipping);
  observer.observe(drawer, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-cart-total']
  });
});